var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.orderData.length),expression:"orderData.length"}],ref:"orderEcharts",staticClass:"orderEcharts",style:({ height: _vm.echartsHeight }),attrs:{"id":"saleEcharts"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }